import { useState, useEffect } from 'react';

/**
 * The local text of an inline editor (a name, a qty, a store). Follows `value` while
 * the field isn't being edited — so an edit from another device shows up — and keeps
 * what the user is typing while it is. Saving stays with the caller (on blur / Enter),
 * so a half-typed value is never written.
 */
export function useDraft(value, editing = false) {
  const [draft, setDraft] = useState(value || '');
  useEffect(() => { if (!editing) setDraft(value || ''); }, [value, editing]);
  return [draft, setDraft];
}
